import { Expose, Type } from 'class-transformer'
import { PenNameListType } from './PenNameListType'

export class PenNameByUserResponse {
  @Expose()
  @Type(() => PenNameListType)
  data: PenNameListType[]

  @Expose()
  page: number

  @Expose()
  total: number

  @Expose()
  totalPenName: number
}
